import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class MonthlyPresenceSearchTask extends GenericRequest {

    _request; // MonthlyPresenceSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.WORKER_CONSTRUCTION_PRESENCES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/monthly-presence-search/MonthlyPresenceSearchTask.js